import BarChart from './BarChart.jsx';

function EmploymentChart({ data }) {
  const options = {
    xaxis: {
      categories: [
        '15',
        '16-24',
        '25-28',
        '29-34',
        '35-44',
        '45-54',
        '55-64',
        '65 и старше',
      ],
    },
  };

  return (
    <BarChart
      series={data}
      options={options}
      title="Доля трудоустроенного населения по полу и возрасту, %"
    />
  );
}

export default EmploymentChart;
